/**
 * Define feature flag here as constants.
 *
 * export const KB_ENHANCEMENTS = 'jsd.px.kb-enhancements';
 *
 * Use them in react components.
 * import { KB_ENHANCEMENTS } from 'feature-flags';
 * import { FeatureFlag } from '@atlassian/help-center-common-component/feature-flag';
 *
 * <FeatureFlag name={KB_ENHANCEMENTS}>
 *  I will be shown in true :-)
 * </FeatureFlag>
 *
 * ========== NOTE ===================
 * BE CAREFUL ADDING FEATURE FLAGS, IF YOU RENAME THEM IT WILL CHANGE THE ANALYTIC CONTEXT
 * NAME AND NO LONGER SEND THE SAME CONTEXT ATTRIBUTE NAME.
 * ===================================
 */

import FeatureGates from '@atlassian/feature-gate-js-client';
import { isFeatureEnabled } from '@atlassian/help-center-common-util/feature-manager';
// Be careful when using these constants directly. In most cases, you should use the function.
export const JSD_REQUEST_TYPE_ONBOARDING = 'jsd-request-type-onboarding';
export const RICH_TEXT_AREA_FIELD = 'jsd.use-adf-default-value-for-textarea';
export const PORTAL_WRM_OPTIMIZATIONS = 'jsd-dw-portal-wrm-optimisations';
export const ENHANCED_RENDER_EXPERIENCE_FOR_KNOWLEDGE_ARTICLES =
    'jsm-enhanced-render-experience-for-knowledge-articles';
export const MULTIPLE_SEARCH_BAR_SUPPORT = 'multiple-search-bar-support';
const JSM_OUTSIDER_COMMENT = 'display-outsider-comment-field_4x7u7';
const JSM_KB_ENABLE_LAYOUT_MACRO_FIX_FOR_EP_VIEW = 'jsm-kb-enable-layout-macro-fix-for-ep-view';
const JSM_ENABLE_ANONYMOUS_CUSTOM_UI = 'fe-jsm-forge-enable-anonymous-custom-ui';
const IS_APOLLO_STARGATE_PATH_ENABLED = 'jsd-apollo-stargate-path_cbi21';
const ENRICH_SENTRY_WITH_PACKAGE_CONTEXT = 'jsm-portal-enrich-sentry-events_ojjpv';
const LOCALE_FIX_FOR_ATLASSIAN_COMPONENTS = 'locale-fix-for-atlassian-components-with-pfe';

const JSM_KB_ANONYMOUS_ACCOUNT_PROJECT_ID_FIX_ENABLED = 'jsm-kb-anonymous-account-project-id-fix-enabled';

const PROFORMA_HARMONISATION_MAIN = 'proforma-harmonisation-main_ca6ff';

const JSM_HELP_SEEKER_CHECK_IN_EXTERNAL_CUSTOMER_LOCKOUT_FILTER =
    'fsn-2827-add-helpseeker-access-check-to-ExternalCustomerLockoutFilter';

const ENABLE_EMBEDDABLE_SMARTLINKS_ON_HELPCENTER = 'jsm-embeddable-smartlinks_08daf';

const HELP_OBJECT_NOT_HYDRATED_ADDITIONAL_LOGS = 'PIR-14919-AI-add-additional-logs-help-objects-not-hydrated';

const FORGE_UI_KIT_2 = 'jsm-forge-ui-kit-2_pb6hu';

export const JSM_CUSTOMER_SSO_EAP = 'jsm-customer-sso-eap_kdznw';

export const REQUEST_TYPE_DELETION_FROM_GROUPS_FIX = 'fix-request-type-deletion-from-rt-groups_taz1f';

export const LOOSELY_LAZY_JS_ERRORS_TO_SENTRY = 'loosely-lazy-js-errors-to-sentry';

const JSM_PORTAL_CUSTOM_THEMING = 'jsm-portal-custom-theming';
export const JSM_REQUEST_TYPE_SEARCH_RESULTS = 'jsm-request-type-search-results_urc3c';
export const DISABLE_INTERACTION_ON_PARENT_SELECT_LAYOUT_BUILDER =
    'jsm-help-center-disable-interaction-on-parent-select_dza90';

export const JSM_SEARCH_ENHANCEMENTS_MILESTONE_1 = 'jsm-portal-search-enhancements-milestone-1_ottdz';

const ADVANCED_HELP_CENTER_IMAGE_RESIZING_OPTION_2 = 'advanced-help-center-image-resizing-option-2_ol17p';

export const UNIFIED_HELP = 'unified-help_81w6g';
const UNIFIED_HELP_BANNER = 'unified-help-banner_ruusz';
const UNIFIED_HELP_TCS_KEY_TO_PRODUCT_MAPPING_ENABLED = 'unified-help-tcs-key-mapping-to-product-enabled_42gc4';
export const UNIFIED_HELP_CONVERSATIONAL_STORE = 'unified-help-center-conversational-store-ui_189jm';
export const UNIFIED_HELP_FALLBACK_MESSAGE = 'unified-help-fallback-message_qtpj4';
export const UNIFIED_HELP_CURATED_SOURCES_DISPLAY = 'unified-help-curated-sources-toggle-display_ejjwp';
export const UNIFIED_HELP_PIPELINE_TESTING = 'unified-help-pipeline-testing';
const UNIFIED_HELP_3LO_MODAL = 'unified-help-3lo-modal_7dwm4';
const UNIFIED_HELP_3LO_MODAL_TESTING = 'unified-help-3lo-modal-testing_4qc4r';
export const UNIFIED_HELP_GOOGLE_DRIVE_INTEGRATION = 'unified-help-google-drive-fe-integration';
export const UNIFIED_HELP_REMOVE_HELP_DESK = 'unified-help-remove-helpdesk_iemzl';
export const UNIFIED_HELP_HELP_CENTER_EXPERIENCE = 'help-center-experience-for-unified-help';
export const UNIFIED_HELP_REPORTING_PAGE = 'help_center_reporting_route';
export const UNIFIED_HELP_REPORTING_CONTENT_GAP = 'hc-reporting-content-gap_0omvu';
export const HELP_CENTER_AI_ANSWERS_REMOVE_ATLASSIAN_ACCOUNT_CHECK =
    'help-center-ai-answers-remove-atlassian-account-check';

const PROFORMA_FIF_FOLLOW_UP = 'platform.proforma-fif-follow-up_59qaa';

export const HELPSEEKER_CAN_REQUEST_NEW_PROJECT_FF = 'end-users-can-request-new-jsm-projects-on-portal-fast-follow';
export const HELPSEEKER_CAN_REQUEST_NEW_PROJECT_DISABLE_SEND_BUTTON_ON_SUBMIT =
    'jsm-end-user-request-service-desk-disable-send-button-on-submit_ed2nr';

export const PERSIST_MANAGE_COLUMNS = 'ff_user_manage_column_poh0z';
const UPDATED_CONTENT_CREATED_BY_ANYONE_FILTER = 'updated-content-for-create-by-anyone-filter';
const UNIFIED_HELP_JSM_REDIRECT_BANNER = 'reroute-jsm-help-center-to-unified-help-center_f9jqr';
const JSM_FORGE_AEGIS_SUPPORT = 'aegis-support-for-jsm-forge_98u60';
const HELPCENTER_GOOGLE_DRIVE_PICKER_ENABLED = 'helpcenter-google-drive-picker-enabled_t1zhp';
const BUSINESS_METRIC_FOR_VERIFICATION_LANDING_PAGE = 'business-metric-for-verification-landing-page_4x9gc';
const HELPDESK_CREATION_ENABLED_ON_HELPCENTER = 'jsm-helpcenter-helpdesk-creation-enabled_82ce6';
const MULTI_HC_KOSH_INTEGRATION = 'multi_hc_kosh_integration';
const SHOW_ERROR_FLAG_WHEN_RESEND_SIGNUP_RATE_LIMITED =
    'show-error-flag-when-resend-signup-link-got-rate-limited_x3t93';
const JSM_FIX_SIGN_UP_OPEN_REDIRECT = 'jsm-fix-sign-up-open-redirect_2vl58';
const FILTER_OUT_ATTACHMENT_ERRORS_FROM_FAMA = 'filter-out-attachment-errors-from-fama-events-in-jsm-portal_tbys3';

const JSM_CS_PRODUCTS_AND_ENTITLEMENTS_M2 = 'products-and-entitlements-m2';
const JSM_CS_PE_M1_5_FAST_FOLLOWS = 'pe-m1.5-fast-follows_5nben';
const HC_REDESIGN_ENABLED = 'hc_redesign';
const FIX_REDIRECTION_TO_NOT_FOUND_PAGE = 'fix-redirection-bug-on-hash-in-url';
const ADS_SPACING_TOKEN = 'ads_spacing_token';
const HC_AI_ANSWERS_STOP_GENERATING_ENABLED = 'hc-ai-answers-stop-generating-enabled';

export const IMPROVED_ERROR_HANDLING_FOR_APPROVAL_EMAIL =
    'phx-230-handle-expired-link-states-for-anonymous-approval-by-email';

export const REINITIALIZE_ANALYTICS_CLIENT = 'reinit-analytics-client-on-user-change_swp15';

export const JSM_VIRTUAL_AGENT_ON_HELP_CENTRE = 'jsm-virtual-agent-on-help-centre_zat8i';

export const isJsmForgeAegisSupportEnabled = () =>
    isFeatureEnabled({
        key: JSM_FORGE_AEGIS_SUPPORT,
        fallback: false,
    });

export const EMAIL_VERIFIED_SIGNAL_ON_CUSTOMERS_PAGE = 'sptn-1697-email-verified-signal-on-customers-page_v2g52';

export const isEmailVerifiedSignalEnabled = () =>
    isFeatureEnabled({
        key: EMAIL_VERIFIED_SIGNAL_ON_CUSTOMERS_PAGE,
        fallback: false,
    });

export const isHelperSeekerCanRequestNewProjectFastFollowEnabled = () =>
    isFeatureEnabled({
        key: HELPSEEKER_CAN_REQUEST_NEW_PROJECT_FF,
        fallback: false,
    });

export const JSM_PORTAL_HIDE_FOOTER_CTA_ON_REQUEST_CREATION = 'jsm-portal-hide-footer-cta-on-request-creation';

export const isHideCTAOnRequestCreationEnabled = () =>
    isFeatureEnabled({
        key: JSM_PORTAL_HIDE_FOOTER_CTA_ON_REQUEST_CREATION,
        fallback: false,
    });

export const isHelperSeekerCanRequestNewProjectDisableSendButtonOnSubmitEnabled = () =>
    isFeatureEnabled({
        key: HELPSEEKER_CAN_REQUEST_NEW_PROJECT_DISABLE_SEND_BUTTON_ON_SUBMIT,
        fallback: false,
    });

const UH_CONFLUENCE_SEARCH_AND_PICK_ENABLED = 'uh-confluence-search-and-pick-enabled_omcnz';

export const isWrmOptimizationsEnabled = () =>
    isFeatureEnabled({
        key: PORTAL_WRM_OPTIMIZATIONS,
        fallback: false,
    });

export const isRichTextAreaEnabled = () =>
    isFeatureEnabled({
        key: RICH_TEXT_AREA_FIELD,
        fallback: false,
    });

export const isTCSKeyToProductMappingEnabled = () =>
    isFeatureEnabled({
        key: UNIFIED_HELP_TCS_KEY_TO_PRODUCT_MAPPING_ENABLED,
        fallback: false,
    });

export const isEnhanceRenderExperienceForKnowledgeArticlesEnabled = () =>
    isFeatureEnabled({
        key: ENHANCED_RENDER_EXPERIENCE_FOR_KNOWLEDGE_ARTICLES,
        fallback: false,
    });

export const isJSMOutsiderCommentEnabled = () =>
    isFeatureEnabled({
        key: JSM_OUTSIDER_COMMENT,
        fallback: false,
    });

export const isMultiSearchEnabled = () =>
    isFeatureEnabled({
        key: MULTIPLE_SEARCH_BAR_SUPPORT,
        fallback: false,
    });

export const isLayoutMacroFixEnabled = () =>
    isFeatureEnabled({
        key: JSM_KB_ENABLE_LAYOUT_MACRO_FIX_FOR_EP_VIEW,
        fallback: false,
    });

export const isAnonymousCustomUIEnabled = () =>
    isFeatureEnabled({
        key: JSM_ENABLE_ANONYMOUS_CUSTOM_UI,
        fallback: false,
    });

export const isApolloStargatePathEnabled = () =>
    isFeatureEnabled({
        key: IS_APOLLO_STARGATE_PATH_ENABLED,
        fallback: false,
    });

export const isEnrichingSentryEnabled = () =>
    isFeatureEnabled({
        key: ENRICH_SENTRY_WITH_PACKAGE_CONTEXT,
        fallback: false,
    });

export const isAnonymousAccountProjectIdFixEnabled = () =>
    isFeatureEnabled({
        key: JSM_KB_ANONYMOUS_ACCOUNT_PROJECT_ID_FIX_ENABLED,
        fallback: false,
    });

export const isProformaHarmonisationFFEnabled = () =>
    isFeatureEnabled({
        key: PROFORMA_HARMONISATION_MAIN,
        fallback: false,
    });

export const isHelpSeekerCheckInExternalCustomerLockoutFilterEnabled = () =>
    isFeatureEnabled({
        key: JSM_HELP_SEEKER_CHECK_IN_EXTERNAL_CUSTOMER_LOCKOUT_FILTER,
        fallback: false,
    });

export const isEmbeddableLinksEnabled = () =>
    isFeatureEnabled({
        key: ENABLE_EMBEDDABLE_SMARTLINKS_ON_HELPCENTER,
        fallback: false,
    });

export const isJsmCustomerSsoEapEnabled = () =>
    isFeatureEnabled({
        key: JSM_CUSTOMER_SSO_EAP,
        fallback: false,
    });

export const isAdditionalLogsForHelpObjectNotHydratedEnabled = () =>
    isFeatureEnabled({
        key: HELP_OBJECT_NOT_HYDRATED_ADDITIONAL_LOGS,
        fallback: false,
    });

export const isRequestTypeDeletionFromGroupsFixEnabled = () =>
    isFeatureEnabled({
        key: REQUEST_TYPE_DELETION_FROM_GROUPS_FIX,
        fallback: false,
    });

export const islooselyLazyJsErrorsToSentryEnabled = () =>
    isFeatureEnabled({
        key: LOOSELY_LAZY_JS_ERRORS_TO_SENTRY,
        fallback: false,
    });

export const isCustomThemingEnabled = () =>
    isFeatureEnabled({
        key: JSM_PORTAL_CUSTOM_THEMING,
        fallback: false,
    });

export const isRequestTypeSearchV2Enabled = () =>
    isFeatureEnabled({
        key: JSM_REQUEST_TYPE_SEARCH_RESULTS,
        fallback: false,
    });

export const isDisablingInteractionOnParentSelectionEnabled = () => {
    return isFeatureEnabled({
        key: DISABLE_INTERACTION_ON_PARENT_SELECT_LAYOUT_BUILDER,
        fallback: false,
    });
};

export const isSearchEnhancementsMilestone1Enabled = () => {
    return isFeatureEnabled({
        key: JSM_SEARCH_ENHANCEMENTS_MILESTONE_1,
        fallback: false,
    });
};

export const isImageResizingOptionTwoEnabled = () =>
    isFeatureEnabled({ key: ADVANCED_HELP_CENTER_IMAGE_RESIZING_OPTION_2, fallback: false });

export const isUnifiedHelpEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP,
        fallback: false,
    });
};

export const isUnifiedHelpBannerEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_BANNER,
        fallback: false,
    });
};

export const isUnifiedHelpConversationalStoreEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_CONVERSATIONAL_STORE,
        fallback: false,
    });
};

export const isUnifiedHelpFallbackMessageEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_FALLBACK_MESSAGE,
        fallback: false,
    });
};
export const isUnifiedHelpCuratedSourcesDisplayEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_CURATED_SOURCES_DISPLAY,
        fallback: false,
    });
};

export const isUnifiedHelpPipelineTestingEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_PIPELINE_TESTING,
        fallback: false,
    });
};

export const isUnifiedHelp3loModalEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_3LO_MODAL,
        fallback: false,
    });
};

export const isUnifiedHelp3loModalTestingEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_3LO_MODAL_TESTING,
        fallback: false,
    });
};

export const isUnifiedHelpGoogleDriveEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_GOOGLE_DRIVE_INTEGRATION,
        fallback: false,
    });
};

export const isUnifiedHelpRemoveHelpDeskEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_REMOVE_HELP_DESK,
        fallback: false,
    });
};

export const isUnifiedHelpReportingPageEnabled = () => {
    return FeatureGates.checkGate(UNIFIED_HELP_REPORTING_PAGE);
};

export const isUnifiedHelpReportingContentGapEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_REPORTING_CONTENT_GAP,
        fallback: false,
    });
};

export const isUIKit2Enabled = () => {
    return isFeatureEnabled({
        key: FORGE_UI_KIT_2,
        fallback: false,
    });
};

export const isProformaFifFollowUpEnabled = () => {
    return isFeatureEnabled({
        key: PROFORMA_FIF_FOLLOW_UP,
        fallback: false,
    });
};

export const isPersistManageColumnsEnabled = () => {
    return isFeatureEnabled({
        key: PERSIST_MANAGE_COLUMNS,
        fallback: false,
    });
};

export const isUpdatedContentForCreatedByAnyoneFilter = () => {
    return isFeatureEnabled({
        key: UPDATED_CONTENT_CREATED_BY_ANYONE_FILTER,
        fallback: false,
    });
};

export const isJSMRedirectBannerEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_JSM_REDIRECT_BANNER,
        fallback: false,
    });
};

export const isUnifiedHelpInJSMEnabled = () => {
    return isFeatureEnabled({
        key: UNIFIED_HELP_HELP_CENTER_EXPERIENCE,
        fallback: false,
    });
};

export const isAtlassianAccountCheckRemoved = () => {
    return isFeatureEnabled({
        key: HELP_CENTER_AI_ANSWERS_REMOVE_ATLASSIAN_ACCOUNT_CHECK,
        fallback: false,
    });
};

export const isConfluenceSearchAndPickEnabled = () => {
    return isFeatureEnabled({
        key: UH_CONFLUENCE_SEARCH_AND_PICK_ENABLED,
        fallback: false,
    });
};

export const isHelpCenterGoogleDrivePickerEnabled = () => {
    return isFeatureEnabled({
        key: HELPCENTER_GOOGLE_DRIVE_PICKER_ENABLED,
        fallback: false,
    });
};

export const isBusinessMetricForVerificationLandingPageEnabled = () => {
    return isFeatureEnabled({
        key: BUSINESS_METRIC_FOR_VERIFICATION_LANDING_PAGE,
        fallback: false,
    });
};

export const isHelpdeskCreationEnabledOnHelpCenter = () => {
    return isFeatureEnabled({
        key: HELPDESK_CREATION_ENABLED_ON_HELPCENTER,
        fallback: false,
    });
};

export const isLocaleFixForAtlassianComponents = () => {
    return isFeatureEnabled({
        key: LOCALE_FIX_FOR_ATLASSIAN_COMPONENTS,
        fallback: false,
    });
};

export const IS_SANITIZE_TEMPLATE_PREVIEW_INPUT_ENABLED = 'jsm-sanitize-template-preview-input';
export const isSanitizeTemplatePreviewInputEnabled = () => {
    return isFeatureEnabled({
        key: IS_SANITIZE_TEMPLATE_PREVIEW_INPUT_ENABLED,
        fallback: false,
    });
};

export const isResendSignupRateLimitedEnabled = () => {
    return isFeatureEnabled({
        key: SHOW_ERROR_FLAG_WHEN_RESEND_SIGNUP_RATE_LIMITED,
        fallback: false,
    });
};

export const isJsmFixSignUpOpenRedirectEnabled = () => {
    return isFeatureEnabled({
        key: JSM_FIX_SIGN_UP_OPEN_REDIRECT,
        fallback: false,
    });
};

export const isFilterOutAttachmentErrorsFromFamaEnabled = () => {
    return isFeatureEnabled({
        key: FILTER_OUT_ATTACHMENT_ERRORS_FROM_FAMA,
        fallback: false,
    });
};

// Virtual Agent (JSM Flux) Feature flags

export const isJsmVirtualAgentOnPortalEnabled = () =>
    isFeatureEnabled({
        key: JSM_VIRTUAL_AGENT_ON_HELP_CENTRE,
        fallback: false,
    });

export const isForceJsmVirtualAgentOnPortalAvailable = () =>
    isFeatureEnabled({
        key: 'force-virtual-agent-on-portal-availability_0fhgs',
        fallback: false,
    });

// JSM Boysenberry feature flags
export const isJsmCsProductsAndEntitlementsM2Enabled = () => {
    return isFeatureEnabled({
        key: JSM_CS_PRODUCTS_AND_ENTITLEMENTS_M2,
        fallback: false,
    });
};
// Products and entitlements M1.5 fast follows
export const isJsmCsPEM15FastFollowsEnabled = () => {
    return isFeatureEnabled({
        key: JSM_CS_PE_M1_5_FAST_FOLLOWS,
        fallback: false,
    });
};

export const isMultiHcKoshIntegrationEnabled = () => {
    return FeatureGates.checkGate(MULTI_HC_KOSH_INTEGRATION);
};

export const isRedirectionToNotFoundPageFixEnabled = () => {
    return FeatureGates.checkGate(FIX_REDIRECTION_TO_NOT_FOUND_PAGE);
};

export const isSanitizationOfPortalDescriptionToRemoveTabIndexEnabled = () => {
    return FeatureGates.checkGate('sanitize_portal_card_description_tabi_index');
};

export const isImprovedAnonymousApprovalByEmailErrorHandlingEnabled = () => {
    return isFeatureEnabled({
        key: IMPROVED_ERROR_HANDLING_FOR_APPROVAL_EMAIL,
        fallback: false,
    });
};

export const isStopGeneratingEnabled = () => {
    return isFeatureEnabled({
        key: HC_AI_ANSWERS_STOP_GENERATING_ENABLED,
        fallback: false,
    });
};

export const isHelpCenterRedesignEnabled = () => {
    return FeatureGates.checkGate(HC_REDESIGN_ENABLED);
};

export const isReinitializeAnalyticsClientEnabled = () => {
    return isFeatureEnabled({
        key: REINITIALIZE_ANALYTICS_CLIENT,
        fallback: false,
    });
};

export const is4xxFilteringFromPremiumSLAEnabled = () => {
    return FeatureGates.checkGate('4xx_filtering_in_request_create_premium_sla_');
};

export const isSendingTraceIdInPremiumSLAEnabled = () => {
    return FeatureGates.checkGate('send_trace_id_in_request_create_premium_sla');
};

export const isSwallowErrorsIfTraceIdNullEnabled = () => {
    return FeatureGates.checkGate('swallow-errors-on-trace-id-null-for-create-request');
};

export const isSpacingTokenEnabled = () => {
    return FeatureGates.checkGate(ADS_SPACING_TOKEN);
};

export const isNewUHBrowseHelpDesksEnabled = () => {
    return FeatureGates.checkGate('unified-help-browse-help-desk');
};
